<template>
  <v-container fluid class="results-container py-6 pa-md-8">
    <v-row justify="center">
      <v-col cols="12" md="10" lg="8">
        
        <template v-if="disponibilidadDominios.disponible === true">
          <v-card class="cyber-card available mb-8 elevation-10">
            <div class="pa-6 pa-md-8">
              <div class="text-center mb-8">
                <div class="icon-circle success-glow mb-4">
                  <v-icon color="#76ff03" size="60">mdi-check</v-icon>
                </div>
                <h2 class="result-title success--text">¡Disponible!</h2>
                <p class="result-subtitle grey--text text--lighten-1">
                  El dominio que buscas está libre para registro.
                </p>
              </div>

              <v-divider class="cyber-divider mb-8"></v-divider>

              <v-row align="center" justify="space-between" class="px-md-4">
                <v-col cols="12" md="6" class="text-center text-md-left mb-6 mb-md-0">
                  <h3 class="domain-name white--text mb-2">
                    {{ disponibilidadDominios.dominio }}
                  </h3>
                  <div class="price-tag success--text">
                    {{ disponibilidadDominios.simbolo }} {{ disponibilidadDominios.precio }}.00
                    <span class="period">/año</span>
                  </div>
                </v-col>

                <v-col cols="12" md="6" lg="5">
                  <div class="contact-box pa-4 d-flex align-center justify-center justify-md-start">
                    <v-icon color="#00e5ff" class="mr-4" size="40">mdi-headset</v-icon>
                    <div class="text-left">
                      <span class="caption grey--text text--lighten-1 d-block mb-1 text-uppercase font-weight-bold">
                        ¿Necesitas asistencia?
                      </span>
                      <span class="contact-number white--text">
                        (505) 2278 3138
                      </span>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </template>

        <template v-else-if="disponibilidadDominios.disponible === false">
          <v-card class="cyber-card unavailable mb-8 elevation-10">
            <div class="pa-6 pa-md-8">
              <div class="text-center mb-8">
                <div class="icon-circle error-glow mb-4">
                  <v-icon color="#ff3366" size="60">mdi-close</v-icon>
                </div>
                <h2 class="result-title error--text">No disponible</h2>
                <p class="result-subtitle grey--text text--lighten-1">
                  Lo sentimos, este dominio ya ha sido registrado.
                </p>
              </div>

              <v-card outlined class="occupied-box d-flex flex-column align-center justify-center pa-6 mx-auto" max-width="600">
                <v-icon color="#ff3366" class="mb-2" size="32">mdi-domain-off</v-icon>
                <h3 class="domain-name white--text">{{ disponibilidadDominios.dominio }}</h3>
                <v-chip
                  color="rgba(255, 51, 102, 0.2)"
                  text-color="#ff3366"
                  label
                  small
                  class="mt-3 font-weight-bold text-uppercase border-error"
                >
                  OCUPADO
                </v-chip>
              </v-card>
            </div>
          </v-card>
        </template>

        <template v-if="dominiosSugeridos.length > 0">
          <div class="mt-10 fade-in">
            <div class="d-flex align-center mb-6 ml-2">
              <v-icon color="#00e5ff" class="mr-3 glow-icon" size="28">mdi-lightbulb-on</v-icon>
              <h3 class="suggestions-title white--text mb-0">Otras opciones disponibles</h3>
            </div>

            <v-simple-table class="cyber-table elevation-5 rounded-lg">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left pl-8 py-4 header-text">Dominio Alternativo</th>
                    <th class="text-right pr-8 py-4 header-text">Precio Anual</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in dominiosSugeridos" :key="'C' + i" class="row-hover">
                    <td class="pl-8 py-4">
                      <span class="suggestion-domain white--text">{{ item.dominio }}</span>
                    </td>
                    <td class="text-right pr-8 py-4">
                      <span class="suggestion-price success--text font-weight-bold">
                        {{ valordominiosugerido(item.moneda, item.precio) }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </template>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import Vue from "vue";
import "vue-toast-notification/dist/theme-sugar.css";

export default {
  name: "DominioDetalle",
  props: {
    mensaje: String,
    response: Number,
  },
  data: () => ({
    dominioModel: {
      dominio: "",
      zona: "",
      idZona: 0,
    },
    disponibilidadDominios: {},
    dominiosSugeridos: [],
  }),
  computed: {
    ...mapGetters(["active", "getdomain", "getzone", "getzoneid"]),
    domainToFind: {
      get() {
        return this.$store.state.domain;
      },
    },
    zoneToFind: {
      get() {
        return this.$store.state.zone;
      },
    },
  },
  watch: {
    domainToFind(newValue) {
      this.dominioModel.dominio = newValue;
      this.availabledomains(newValue);
    },
    zoneToFind() {
      this.dominioModel.dominio = this.$store.state.domain;
      this.availabledomains(this.dominioModel.dominio);
    },
  },
  mounted() {
    let tempDomain = localStorage.getItem("tempDomain");
    let tempZone = localStorage.getItem("tempZone");
    let tempZoneId = localStorage.getItem("tempZoneId");

    if (tempDomain) {
      this.availabledomainsNavigate(tempDomain, tempZone, tempZoneId);
    }
  },
  methods: {
    toasterMessageResponse: function (msg, type) {
      Vue.$toast.open({
        message: msg,
        type: type === "error" ? "error" : "success",
      });
    },
    valordominiosugerido: function (moneda, valor) {
      return (moneda == "Dólar" ? "$" : "C$") + "" + valor.toFixed(2);
    },
    availabledomains: async function () {
      await this.$http
        .get(
          this.$keys("DISPONIBILIDAD_DOMINIO") +
            "?dominio=" +
            this.dominioModel.dominio +
            "&zona=" +
            this.getzone +
            "&idZona=" +
            this.getzoneid
        )
        .then((response) => {
          if (response.status === 200) {
            if (response.data.disponibilidadDominios) {
              this.disponibilidadDominios = response.data.disponibilidadDominios[0];
              this.dominiosSugeridos = response.data.disponibilidadDominios.filter(
                (x) => x.sugerido === true
              );
            }
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 409) {
            this.toasterMessageResponse(error.response.data.mensaje, "error");
          }
        });
    },
    availabledomainsNavigate: async function (tempDomain, tempZone, tempZoneId) {
      await this.$http
        .get(
          this.$keys("DISPONIBILIDAD_DOMINIO") +
            "?dominio=" +
            tempDomain +
            "&zona=" +
            tempZone +
            "&idZona=" +
            tempZoneId
        )
        .then((response) => {
          if (response.status === 200 && response.data.disponibilidadDominios) {
            this.disponibilidadDominios = response.data.disponibilidadDominios[0];
            this.dominiosSugeridos = response.data.disponibilidadDominios.map(
              (obj) => ({
                ...obj,
                dns: obj.dominio.substring(0, obj.dominio.indexOf(".")),
              })
            );
          }
        });
      localStorage.removeItem("tempDomain");
      localStorage.removeItem("tempZone");
      localStorage.removeItem("tempZoneId");
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Fira+Code:wght@400;600&family=Montserrat:wght@700&display=swap');

/* --- CONTENEDOR GENERAL --- */
.results-container {
  background-color: transparent; /* Asume que el padre tiene el fondo oscuro o es transparente */
  font-family: 'Montserrat', sans-serif;
}

/* --- TARJETAS --- */
.cyber-card {
  background-color: #09101a !important;
  border: 1px solid #1a2634 !important;
  color: #fff !important;
}

/* Bordes Superiores de Estado */
.cyber-card.available {
  border-top: 4px solid #76ff03 !important; /* Verde Neón */
  box-shadow: 0 4px 20px rgba(118, 255, 3, 0.1) !important;
}

.cyber-card.unavailable {
  border-top: 4px solid #ff3366 !important; /* Rojo Neón */
  box-shadow: 0 4px 20px rgba(255, 51, 102, 0.1) !important;
}

/* Iconos Circulares */
.icon-circle {
  display: inline-flex;
  padding: 15px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.05);
}
.success-glow { box-shadow: 0 0 20px rgba(118, 255, 3, 0.3); }
.error-glow { box-shadow: 0 0 20px rgba(255, 51, 102, 0.3); }

/* Textos de Resultado */
.result-title {
  font-size: 2.5rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.result-subtitle { font-size: 1.1rem; }

/* Separador */
.cyber-divider { border-color: #1a2634 !important; }

/* --- INFO DEL DOMINIO --- */
.domain-name {
  font-family: 'Fira Code', monospace;
  font-size: 2rem;
  letter-spacing: -1px;
}

.price-tag {
  font-size: 2rem;
  font-weight: 700;
  font-family: 'Fira Code', monospace;
}
.period {
  font-size: 1.2rem;
  font-weight: 400;
  opacity: 0.8;
}

/* Caja de Contacto */
.contact-box {
  background: rgba(0, 229, 255, 0.05);
  border: 1px solid rgba(0, 229, 255, 0.2);
  border-radius: 8px;
}
.contact-number {
  font-family: 'Fira Code', monospace;
  font-size: 1.4rem;
  font-weight: 700;
  color: #00e5ff !important;
}

/* Caja de "Ocupado" */
.occupied-box {
  background-color: rgba(255, 51, 102, 0.05) !important;
  border: 1px dashed rgba(255, 51, 102, 0.3) !important;
}
.border-error { border: 1px solid rgba(255, 51, 102, 0.5) !important; }

/* --- TABLA DE SUGERENCIAS --- */
.suggestions-title {
  font-family: 'Montserrat', sans-serif;
  font-size: 1.5rem;
  letter-spacing: 0.5px;
}

.cyber-table {
  background-color: #09101a !important;
  border: 1px solid #1a2634;
}

.cyber-table thead tr th {
  background-color: #050a10 !important;
  color: #00e5ff !important; /* Texto cabecera cian */
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  text-transform: uppercase;
  border-bottom: 1px solid #1a2634 !important;
}

.cyber-table tbody tr {
  background-color: transparent !important;
  transition: background-color 0.2s;
}

.cyber-table tbody tr:hover {
  background-color: rgba(0, 229, 255, 0.05) !important;
}

.cyber-table tbody tr td {
  border-bottom: 1px solid #1a2634 !important;
}

.suggestion-domain {
  font-family: 'Fira Code', monospace;
  font-size: 1.2rem;
  letter-spacing: 0.5px;
}

.suggestion-price {
  font-family: 'Fira Code', monospace;
  font-size: 1.2rem;
}

.glow-icon { filter: drop-shadow(0 0 10px #00e5ff); }

/* Animación de entrada */
.fade-in {
  animation: fadeIn 0.8s ease-out;
}
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Colores de Vuetify overrides */
.success--text { color: #76ff03 !important; } /* Verde Neón */
.error--text { color: #ff3366 !important; } /* Rojo Neón */
</style>